<a (click)="clickEmit()" [attr.color]="color" size="small" [class]="getClass()"
  ><ng-content></ng-content>
</a>
